/* eslint-disable @typescript-eslint/ban-types */

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MainSubjectButton, ChildrenSubjectsContainer, ChildSubjectButton, ButtonContainer } from './styles';
import ISubjects from '../../@types/ISubjects';
import Chapters from '../side-bar/sections';

interface SubjectButtonsProps {
  subject: ISubjects,
  setSelectedSubject: Function,
  selectedSubject: string,
  onClick: Function
}

// eslint-disable-next-line max-len
function MainSubjectButtonComponent(subject: ISubjects, setSelectedSubject: Function, onClick: Function) {
  const { title, subtitle, slug } = subject;
  const navigate = useNavigate();
  const params = useParams();
  const INDEX_PAGE_NAME = 'inicio';

  const handleClick = () => {
    navigate(`/${slug}/${INDEX_PAGE_NAME}`);
    setSelectedSubject(slug);
    onClick();
  };

  return (
    <MainSubjectButton
      type="button"
      textColor={10}
      subject="portuguese"
      highlighted={params.subject === slug}
      color={50}
      hoverColor={40}
      onClick={handleClick}
    >
      {title}
      {subtitle && <span className="subtitle">{subtitle}</span>}
    </MainSubjectButton>
  );
}

export default function SubjectButtons(
  { subject, setSelectedSubject, selectedSubject, onClick }: SubjectButtonsProps
) {
  const params = useParams();
  const containerHighlighted = params.subject === subject.slug;

  if (subject.children && subject.children.length > 0) {
    const navigate = useNavigate();

    return (
      <ButtonContainer highlighted={containerHighlighted}>
        {MainSubjectButtonComponent(subject, setSelectedSubject, onClick)}
        {
          (subject.slug === selectedSubject || subject.slug === params.subject)
            && subject.children.length > 0
            && (
              <>
                <ChildrenSubjectsContainer style={(subject.slug === 'conteudos-complementares') ? { flexDirection: 'column' } : { flexDirection: 'row' }}>
                  {subject.children.map((childSubject, index) => (
                    <>
                      <ChildSubjectButton
                        type="button"
                        textColor={10}
                        subject="portuguese"
                        color={60}
                        hoverColor={40}
                        key={index}
                        onClick={() => {
                      navigate(`/${subject.slug}/${childSubject.slug}`);
                      setSelectedSubject(subject.slug);
                      onClick();
                    }}
                        highlighted={params.page === childSubject.slug
                      && params.subject === subject.slug}
                      >
                        {childSubject.title}
                        {childSubject.subtitle && <span className="subtitle">{childSubject.subtitle}</span>}
                      </ChildSubjectButton>
                    </>
              ))}
                </ChildrenSubjectsContainer>
                <Chapters
                  typeTheme="portuguese"
                  onClick={() => {
                    onClick();
                }}
                />
              </>
            )
        }
      </ButtonContainer>
    );
  }

  return (
    <ButtonContainer highlighted={containerHighlighted}>
      {MainSubjectButtonComponent(subject, setSelectedSubject, onClick)}

      {(subject.slug === selectedSubject || subject.slug === params.subject) && containerHighlighted
      && (
      <Chapters
        typeTheme="portuguese"
        onClick={() => {
                          onClick();
                        }}
      />
      )}
    </ButtonContainer>
  );
}
